import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { TPermissionAction } from '@/shared/features/permissions/actions';
import { usePermissionCheck } from '@/shared/features/permissions/hooks/use-permission-check/use-permission-check';
import { TPermissionCheckRule } from '@/shared/features/permissions/permission-check.types';
import { ResourceGroupFragment } from '@/shared/types/types.generated';

export type TUseGroupScopedActionParams = {
  action: TPermissionAction;
  groupId?: string | null;
};

export type TGroupScopedActionSelectProps = {
  required: boolean;
  showNoGroupOption: boolean;
  groupFilter: (group: ResourceGroupFragment) => boolean;
};

export const normalizeGroupScopedActionId = (groupId?: string | null) => {
  if (!groupId || groupId === UNGROUPED_RESOURCES_GROUP_ID) {
    return undefined;
  }

  return groupId;
};

export const useGroupScopedAction = ({
  action,
  groupId,
}: TUseGroupScopedActionParams) => {
  const { can } = usePermissionCheck();
  const normalizedGroupId = normalizeGroupScopedActionId(groupId);
  const canUseAtRoot = can(action, '*');
  const requiresGroup = !canUseAtRoot;
  const permission: TPermissionCheckRule = normalizedGroupId
    ? { action, ids: normalizedGroupId }
    : { action };

  return {
    groupId: normalizedGroupId,
    canUseAtRoot,
    requiresGroup,
    permission,
    groupSelectProps: {
      required: requiresGroup,
      showNoGroupOption: !requiresGroup,
      groupFilter: (group: ResourceGroupFragment) =>
        !requiresGroup || can(action, group.groupId),
    },
  };
};
